import { UserDetails } from '@pages/Users/UserDetails';

export const MyAccountDetails = () => {
  return <UserDetails />;
};
